<div *ngIf="show" class="alert-overlay" (click)="close()">
  <div class="alert-dialog" [ngClass]="'alert-' + config.type" (click)="$event.stopPropagation()">
    <!-- Icon -->
    <div class="alert-icon-wrapper">
      <div class="alert-icon" [ngClass]="'icon-' + config.type">
        <i class="material-icons" *ngIf="config.type === 'info'">info</i>
        <i class="material-icons" *ngIf="config.type === 'warning'">warning</i>
        <i class="material-icons" *ngIf="config.type === 'error'">error</i>
        <i class="material-icons" *ngIf="config.type === 'success'">check_circle</i>
      </div>
    </div>

    <!-- Content -->
    <div class="alert-content">
      <h3 class="alert-title">{{ config.title }}</h3>
      <p class="alert-message">{{ config.message }}</p>
    </div>

    <!-- Actions -->
    <div class="alert-actions">
      <button
        *ngIf="config.showCancel"
        type="button"
        class="btn btn-secondary"
        (click)="onCancel()"
      >
        {{ config.cancelText || 'Cancel' }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onConfirm()"
      >
        {{ config.confirmText || 'OK' }}
      </button>
    </div>
  </div>
</div>

